import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';
import { fetchHandler, postHandler } from '../../utils/apiUtils';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

export const searchCountryWithPagination = async (
  {
    CountryCode,
    CountryName,
    CountryCode2,
    CountryNumericCode,
    Active,
    page,
    pageSize,
    sortBy,
  }
) => {
  const queryParams = [];

  if (CountryCode && CountryCode.trim() !== '') {
    queryParams.push(`CountryCode=${encodeURIComponent(CountryCode.trim())}`);
  }

  if (CountryName && CountryName.trim() !== '') {
    queryParams.push(`CountryName=${encodeURIComponent(CountryName.trim())}`);
    queryParams.push('CountryName=Contains');
  }

  if (CountryCode2 && CountryCode2.trim() !== '') {
    queryParams.push(`CountryCode2=${encodeURIComponent(CountryCode2.trim())}`);
  }

  if (CountryNumericCode && CountryNumericCode.trim() !== '') {
    queryParams.push(`CountryNumericCode=${encodeURIComponent(CountryNumericCode.trim())}`);
  }

  if (Active != null) {
    queryParams.push(`Active=${Active}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/Country/Search/By?${queryParams.join('&')}`
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

export const createCountry = async (payload) => postHandler(axiosInstance, '/Country/Create', payload);

export const getCountryByCountryId = async (
  { countryCode },
  abortController
) => fetchHandler(axiosInstance, `Country/countryCodes/${countryCode}`, null, abortController);

export const updateCountry = async (payload) => postHandler(axiosInstance, 'Country/Save ', payload);
